module.exports = __webpack_public_path__ + "media/brands/mtz-6b08523f.png";